import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { api } from './api.js';
import Login from './routes/Login.jsx';
import ServerPicker from './routes/ServerPicker.jsx';
import GuildLayout from './routes/GuildLayout.jsx';
import ConfigLogs from './routes/ConfigLogs.jsx';
import ConfigWelcome from './routes/ConfigWelcome.jsx';
import ConfigAutoRole from './routes/ConfigAutoRole.jsx';
import ConfigReactionRoles from './routes/ConfigReactionRoles.jsx';
import ConfigMirrors from './routes/ConfigMirrors.jsx';
import ModLog from './routes/ModLog.jsx';
import Warnings from './routes/Warnings.jsx';
import Members from './routes/Members.jsx';
import MemberDetail from './routes/MemberDetail.jsx';
import Owner from './routes/Owner.jsx';
import Overview from './routes/Overview.jsx';
import Invites from './routes/Invites.jsx';
import BotDms from './routes/BotDms.jsx';
import ChannelMods from './routes/ChannelMods.jsx';
import Restrictions from './routes/Restrictions.jsx';
import SupportTickets from './routes/SupportTickets.jsx';
import AuditSearch from './routes/AuditSearch.jsx';
import Polls from './routes/Polls.jsx';

export default function App() {
  const [me, setMe] = useState({ loading: true });

  useEffect(() => {
    api.me()
      .then(data => setMe({ loading: false, ...data }))
      .catch(() => setMe({ loading: false, user: null }));
  }, []);

  if (me.loading) return <div className="empty">Loading…</div>;

  if (!me.user) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<ServerPicker me={me} setMe={setMe} />} />
      {me.isOwner && <Route path="/owner" element={<Owner me={me} setMe={setMe} />} />}
      <Route path="/g/:guildId" element={<GuildLayout me={me} setMe={setMe} />}>
        <Route index element={<Navigate to="overview" replace />} />
        <Route path="overview" element={<Overview />} />
        <Route path="config" element={<Navigate to="logs" replace />} />
        <Route path="config/logs" element={<ConfigLogs />} />
        <Route path="config/welcome" element={<ConfigWelcome />} />
        <Route path="config/reactions" element={<ConfigReactionRoles />} />
        <Route path="config/mirrors" element={<ConfigMirrors />} />
        <Route path="config/autorole" element={<Navigate to="../welcome" replace />} />
        <Route path="audit" element={<AuditSearch />} />
        <Route path="modlog" element={<ModLog />} />
        <Route path="warnings" element={<Warnings />} />
        <Route path="members" element={<Members />} />
        <Route path="invites" element={<Invites />} />
        <Route path="bot-dms" element={<BotDms />} />
        <Route path="channel-mods" element={<ChannelMods />} />
        <Route path="restrictions" element={<Restrictions />} />
        <Route path="tickets" element={<SupportTickets />} />
        <Route path="polls" element={<Polls />} />
        <Route path="users/:userId" element={<MemberDetail />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
